import { ReactNode, useMemo } from 'react';
import { Box, FormControlLabel, ListItemIcon, MenuItem, Radio } from '@mui/material';
import CircleRounded from '@mui/icons-material/Circle';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import getLanguageData from '../language-data';
import styles from './index.module.scss';

export interface LanguageType {
    value: string;
    title: any;
    icon?: ReactNode;
}

export interface LanguageSwitcherLineProps {
    language: LanguageType;
    onChange?: () => void;
    selected?: boolean;
    variant?: 'default' | 'no-flag';
    countryCode?: string;
}

const LanguageSwitcherLine = ({ language, onChange, selected, variant, countryCode }: LanguageSwitcherLineProps) => {
    const data = useMemo(() => {
        const languageData = getLanguageData(countryCode);
        return languageData.find((i) => i.key === language?.value);
    }, [language, countryCode]);

    const content = useMemo(() => {
        if (variant === 'no-flag') {
            return (
                <>
                    {language.title}
                    <Box className={styles.gapStyle} />
                    <FormControlLabel
                        className={styles.label}
                        value={language.value}
                        control={
                            <Radio
                                checked={selected}
                                color="primary"
                                icon={<CircleRounded className={styles.emptyIconStyle} />}
                                checkedIcon={<CheckCircleRoundedIcon className={styles.activeIconStyle} />}
                            />
                        }
                        label=""
                    />
                </>
            );
        }

        return (
            <>
                <ListItemIcon>{data?.icon}</ListItemIcon>
                {language.title}
                <Box className={styles.gapStyle} />
                <FormControlLabel
                    className={styles.label}
                    value={language.value}
                    control={<Radio checked={selected} color="primary" />}
                    label=""
                />
            </>
        );
    }, [variant, data, language, selected]);

    return (
        <MenuItem className={styles.line} onClick={onChange} key={language.value} value={language.value}>
            {content}
        </MenuItem>
    );
};

export default LanguageSwitcherLine;
